import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
import type { PillarPageContent } from '../types/pillarPage';
type PillarsSectionProps = {
  content: PillarPageContent['pillars'];
};
export function PillarsSection({
  content
}: PillarsSectionProps) {
  return <section className="w-full border-y border-accent-deep/40 bg-surface/40 py-28 lg:py-40" data-id="element-225" data-mp="1yfs7e4twr1ov">
      <div className="mx-auto w-full max-w-[1240px] px-6 sm:px-10" data-id="element-226" data-mp="1tgfmvqqie6pg">
        <Reveal data-id="element-227" data-mp="1thqr1rnv9gh3">
          <Eyebrow data-id="element-228" data-mp="1te2x4reies1u">{content.eyebrow}</Eyebrow>
          <h2 className="mt-6 max-w-2xl text-3xl font-extrabold leading-[1.1] tracking-[-0.025em] text-bone sm:text-4xl lg:text-[3rem]" data-id="element-229" data-mp="1pdrbpcebonpb">
            {content.title}
          </h2>
        </Reveal>

        <ol className="mt-16 space-y-4" data-id="element-230" data-mp="1fhobwd6y115j">
          {content.items.map((pillar, i) => <Reveal as="li" key={pillar.number} delay={0.05 * i} data-id="element-231" data-mp="3eu0i925bfmko" data-mpi={i}>
              <article className="group grid grid-cols-1 gap-6 rounded-3xl border border-accent-deep/60 bg-surface p-8 transition-[border-color] duration-200 ease-elite hover:border-accent/40 lg:grid-cols-12 lg:items-start lg:gap-10 lg:p-10" data-id="element-232" data-mp="39unxcmy08pkq">
                <div className="lg:col-span-2" data-id="element-233" data-mp="6bj3rv4dqxom">
                  <span className="block text-4xl font-extrabold leading-none tracking-[-0.04em] text-accent/40 transition-colors duration-200 ease-elite group-hover:text-accent/70 lg:text-6xl" data-id="element-234" data-mp="68544un3p2kv">
                    {pillar.number}
                  </span>
                  <span className="mt-4 block text-[11px] font-bold uppercase tracking-label text-bone" data-id="element-235" data-mp="l0p3dk74qpx1">
                    {pillar.label}
                  </span>
                </div>
                <div className="lg:col-span-5" data-id="element-236" data-mp="bach9njo2oos">
                  <h3 className="text-xl font-bold leading-snug tracking-[-0.01em] text-bone sm:text-2xl" data-id="element-237" data-mp="b7gjq0bqe20v">
                    {pillar.headline}
                  </h3>
                </div>
                <div className="lg:col-span-5" data-id="element-238" data-mp="13wx7ulsbiwra">
                  <p className="text-[15px] leading-relaxed text-ash" data-id="element-239" data-mp="18pgl1hn3fpvk">{pillar.text}</p>
                </div>
              </article>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}